import { ArrowLeft } from 'lucide-react';
import Image from 'next/image';
import { ReactElement } from 'react';

import { Button, Text } from '@/design-system/components/ui';

interface OnboardingColumnsLayoutProps {
  buttons?: ReactElement;
  canGoBack?: boolean;
  imageSrc?: string;
  leftContent: ReactElement;
  maxImgHeight?: string;
  onGoBack?: () => void;
  subtitle?: string | ReactElement;
  title?: string;
}

export const OnboardingColumnsLayout = ({
  buttons,
  canGoBack,
  imageSrc,
  leftContent,
  maxImgHeight,
  onGoBack,
  subtitle,
  title,
}: OnboardingColumnsLayoutProps) => {
  return (
    <div className="tw:flex tw:flex-row tw:items-center tw:justify-center tw:gap-6">
      <div className={`tw:w-full ${imageSrc ? 'tw:md:w-8/12' : 'tw:md:w-6/12'}`}>
        <div
          className={`tw:flex tw:flex-col tw:gap-2 tw:md:gap-3 tw:items-center ${imageSrc ? 'tw:md:items-start tw:md:pl-24 tw:lg:pl-48' : 'tw:md:items-center'}`}
        >
          {canGoBack && (
            <Button variant="ghost" className="tw:w-fit tw:pl-0 tw:text-black" onClick={onGoBack}>
              <ArrowLeft />
              Back
            </Button>
          )}
          {title && (
            <h3 className="tw:font-clash-grotesk tw:text-[1.5rem] tw:leading-[1.3] tw:font-medium tw:w-full tw:max-w-[465px] tw:md:max-w-[500px]">
              {title}
            </h3>
          )}
          {subtitle && (
            <Text
              variant="body-md"
              color="muted"
              weight="medium"
              className="tw:w-full tw:max-w-[465px] tw:md:max-w-[500px]"
            >
              {subtitle}
            </Text>
          )}
          <div className="tw:my-3 tw:w-full tw:max-w-[465px]">{leftContent}</div>
          {/* Shares the content's column so actions line up with what they act
              on — rendered bare, the button floated free of the fields above it. */}
          {buttons && <div className="tw:w-full tw:max-w-[465px]">{buttons}</div>}
        </div>
      </div>
      {imageSrc && (
        <div className="tw:hidden tw:md:block tw:w-full tw:md:w-6/12">
          <Image
            src={imageSrc}
            width={0}
            height={0}
            sizes="100vw"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: maxImgHeight,
            }}
            alt="Fuul | The web3 growth platform"
          />
        </div>
      )}
    </div>
  );
};
